/* eslint-disable @typescript-eslint/no-use-before-define */
import * as React from 'react';
import {
  Button,
  ButtonWidth,
} from '@practicegenius/pg-ui/src/base/Material/components/Button';
import {Field} from '../../../@practicegenius/react-final-form';
import {Modal} from '../../../components/Modal/Modal';
import {ModalButtons} from '../../../components/Modal/layout';
import {Content, Title} from '../../../shared/utils/sharedStyledElements';

export const unregisteredAccountMethods = Object.freeze({
  REWARDS_NUMBER: 'rewards_number',
  TEMP_REG_CODE: 'temp_reg_code',
});

const unregisteredAccountMethodDescriptions = {
  [unregisteredAccountMethods.REWARDS_NUMBER]: 'Rewards Number',
  [unregisteredAccountMethods.TEMP_REG_CODE]: 'Temporary Registration Code',
};

type Props = {
  isOpen: boolean;
  close: () => void;
  methodUsed: typeof unregisteredAccountMethods[keyof typeof unregisteredAccountMethods];
  redirectTo: (loginValue: string) => string;
};

export function UnregisteredAccountModal({
  isOpen,
  close,
  methodUsed,
  redirectTo,
}: Props) {
  return (
    <Modal isOpen={isOpen} close={close}>
      <Title>Let's finish registering your account</Title>
      <Content>
        The account associated with this{' '}
        {unregisteredAccountMethodDescriptions[methodUsed]} is not set up.
        <br />
        Let's finish registering so you can start earning rewards.
      </Content>
      <ModalButtons>
        <Button color="secondary" width={ButtonWidth.WIDE} onClick={close}>
          Cancel
        </Button>
        {/* When this modal is showing, the login value is the rewards card number */}
        <Field name="login">
          {({input: {value: data}}) => (
            <Button
              width={ButtonWidth.WIDE}
              color="primary"
              href={redirectTo(data)}
              data-testid="register"
            >
              Finish Registering
            </Button>
          )}
        </Field>
      </ModalButtons>
    </Modal>
  );
}
